// This list is generated from the font-awesome v6 brands icons list stored here:
// https://github.com/FortAwesome/Font-Awesome/blob/6.x/sprites/brands.svg?short_path=c2ccd2b
//
//
// Here's a script you can run in your browser console
// (it will only work in browser console cause node.js doesn't support DOMParser api)
// to generate this list:
//
// ```javascript
// function extractSymbolIds(svgString) {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(svgString, "image/svg+xml");
//   const symbols = doc.querySelectorAll("symbol");
//
//   return Array.from(symbols).map(symbol => symbol.id);
// }
//
// // Example usage:
// const svgString = `<?xml version="1.0" encoding="UTF-8"?>
// <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
// <symbol id="mixer" viewBox="0 0 512 512"></symbol>
// <symbol id="node" viewBox="0 0 640 512"></symbol>
// <symbol id="waze" viewBox="0 0 512 512"></symbol>
// </svg>
// ...
// `;
//
// const iconIds = extractSymbolIds(svgString);
// console.log(iconIds);
// ```

export const fontAwesomeV6BrandsIconsList = [
  'mixer',
  'node',
  'waze',
  'jenkins',
  'google-scholar',
  'weixin',
  'cc-discover',
  '42-group',
  'gitlab',
  'figma',
  'wordpress-simple',
  'square-tumblr',
  'squarespace',
  'watchman-monitoring',
  'app-store',
  'octopus-deploy',
  'airbnb',
  'dyalog',
  'joomla',
  'slack',
  'linux',
  'firstdraft',
  'square-font-awesome',
  'diaspora',
  'square-steam',
  'creative-commons-pd-alt',
  'stack-exchange',
  'deezer',
  'google-wallet',
  'git-alt',
  'space-awesome',
  'java',
  'git',
  'opensuse',
  'tumblr',
  'wordpress',
  'jira',
  'dhl',
  'square-lastfm',
  'hips',
  'wpressr',
  'x-twitter',
  'itch-io',
  'slideshare',
  'd-and-d',
  'mandalorian',
  'black-tie',
  'creative-commons-sampling-plus',
  'canadian-maple-leaf',
  'intercom',
  'staylinked',
  'shopware',
  'stack-overflow',
  'fort-awesome-alt',
  'hashnode',
  'square-pied-piper',
  'square-web-awesome-stroke',
  'weebly',
  'edge-legacy',
  'hacker-news',
  'firefox',
  'yarn',
  'letterboxd',
  'threads',
  'ioxhost',
  'envira',
  'alipay',
  'creative-commons-nc-jp',
  'digg',
  'readme',
  'creative-commons-nc-eu',
  'deskpro',
  'y-combinator',
  'google',
  'playstation',
  'gratipay',
  'bluetooth-b',
  'twitch',
  'houzz',
  'qq',
  'aviato',
  'sitrox',
  'docker',
  'yandex-international',
  'pushed',
  'keybase',
  'gg-circle',
  'hive',
  'studiovinari',
  'forumbee',
  'js',
  'ubuntu',
  'shopify',
  'fedex',
  'tiktok',
  'wirsindhandwerk',
  'jsfiddle',
  'square-letterboxd',
  'files-pinwheel',
  'ideal',
  'avianex',
  'grav',
  'wizards-of-the-coast',
  'bity',
  'creative-commons-sa',
  'cuttlefish',
  'github-alt',
  'viber',
  'opera',
  'creative-commons-nd',
  'pied-piper',
  'pied-piper-pp',
  'etsy',
  'viadeo',
  'creative-commons-zero',
  'hubspot',
  'buffer',
  'phabricator',
  'mizuni',
  'hotjar',
  'researchgate',
  'google-drive',
  'patreon',
  'mdb',
  'apple-pay',
  'contao',
  'leanpub',
  'pied-piper-alt',
  'mendeley',
  'nutritionix',
  'android',
  'amazon-pay',
  'autoprefixer',
  'kaggle',
  'angrycreative',
  'dropbox',
  'trade-federation',
  'korvue',
  'python',
  'shirtsinbulk',
  'square-dribbble',
  'mailchimp',
  'web-awesome',
  'cc-jcb',
  'angular',
  'itunes-note',
  'cloudsmith',
  'bitbucket',
  'ethereum',
  'unsplash',
  'perbyte',
  'pagelines',
  'itunes',
  'wix',
  '500px',
  'swift',
  'cloudversify',
  'square-viadeo',
  'apper',
  'galactic-senate',
  'algolia',
  'phoenix-squadron',
  'trello',
  'deviantart',
  'bots',
  'kickstarter-k',
  'optin-monster',
  'stumbleupon',
  'soundcloud',
  'creative-commons-remix',
  'schlix',
  'meetup',
  'square-hacker-news',
  'amilia',
  'aws',
  'yammer',
  'mastodon',
  'cc-apple-pay',
  'gofore',
  'linkedin-in',
  'tencent-weibo',
  'golang',
  'bootstrap',
  'pix',
  'signal-messenger',
  'github',
  'medrt',
  'dashcube',
  'opencart',
  'think-peaks',
  'reddit',
  'gitter',
  'chrome',
  'untappd',
  'fantasy-flight-games',
  'whatsapp',
  'salesforce',
  'usb',
  'ns8',
  'bluesky',
  'vuejs',
  'quinscape',
  'renren',
  'freebsd',
  'hire-a-helper',
  'rebel',
  'whmcs',
  'rev',
  'jxl',
  'spotify',
  'dart-lang',
  'css3',
  'redhat',
  'wpexplorer',
  'atlassian',
  'steam',
  'centos',
  'windows',
  'periscope',
  'apple',
  'square-snapchat',
  'usps',
  'google-pay',
  'buy-n-large',
  'speakap',
  'creative-commons-nc',
  'red-river',
  'stripe',
  'cmplid',
  'app-store-ios',
  'youtube',
  'upwork',
  'odnoklassniki',
  'webflow',
  'telegram',
  'square-git',
  'instalod',
  'raspberry-pi',
  'ups',
  'audible',
  'codiepie',
  'less',
  'scribd',
  'safari',
  'monero',
  'css',
  'facebook',
  'sketch',
  'digital-ocean',
  'square-facebook',
  'line',
  'square-threads',
  'r-project',
  'battle-net',
  'umbraco',
  'php',
  'lyft',
  'pixiv',
  'unity',
  'joget',
  'ussunnah',
  'sellsy',
  'fonticons',
  'viacoin',
  'openid',
  'hooli',
  'behance',
  'orcid',
  'invision',
  'square-google-plus',
  'gripfire',
  'phoenix-framework',
  'rust',
  'supple',
  'discourse',
  'napster',
  'xing',
  'vimeo-v',
  'cc-mastercard',
  'square-vimeo',
  'snapchat',
  'modx',
  'first-order-alt',
  'old-republic',
  'google-plus-g',
  'wpforms',
  'expeditedssl',
  'stripe-s',
  'maxcdn',
  'adn',
  'the-red-yeti',
  'pinterest-p',
  'wolf-pack-battalion',
  'sith',
  'yahoo',
  'evernote',
  'jedi-order',
  'medapps',
  'zhihu',
  'padlet',
  'page4',
  'accusoft',
  'linkedin',
  'ember',
  'paypal',
  'gg',
  'critical-role',
  'buysellads',
  'delicious',
  'dochub',
  'fedora',
  'square-font-awesome-stroke',
  'codepen',
  'sourcetree',
  'grunt',
  'dev',
  'skype',
  'affiliatetheme',
  'microblog',
  'brave',
  'amazon',
  'blogger',
  'square-upwork',
  'pinterest',
  'stubber',
  'bimobject',
  'discord',
  'creative-commons-by',
  'sticker-mule',
  'fly',
  'medium',
  'nfc-symbol',
  'font-awesome',
  'instagram',
  'kickstarter',
  'product-hunt',
  'square-instagram',
  'square-twitter',
  'confluence',
  'screenpal',
  'square-x-twitter',
  'reacteurope',
  'gulp',
  'fonticons-fi',
  'yelp',
  'flipboard',
  'simplybuilt',
  'deploydog',
  'cc-stripe',
  'free-code-camp',
  'square-whatsapp',
  'stumbleupon-circle',
  'lastfm',
  'quora',
  'meta',
  'npm',
  'cc-paypal',
  'mixcloud',
  'cc-diners-club',
  'searchengin',
  'fulcrum',
  'artstation',
  'brave-reverse',
  'connectdevelop',
  'blackberry',
  'stackpath',
  'elementor',
  'bluetooth',
  'themeisle',
  'resolving',
  'cc-amazon-pay',
  'skyatlas',
  'yandex',
  'dailymotion',
  'imdb',
  'weibo',
  'laravel',
  'ebay',
  'glide',
  'first-order',
  'square-web-awesome',
  'servicestack',
  'flickr',
  'gitkraken',
  'wikipedia-w',
  'edge',
  'google-plus',
  'debian',
  'square-youtube',
  'nfc-directional',
  'accessible-icon',
  'centercode',
  'mintbit',
  'magento',
  'flutter',
  'earlybirds',
  'bitcoin',
  'erlang',
  'wpbeginner',
  'osi',
  'twitter',
  'cpanel',
  'themeco',
  'square-github',
  'dribbble',
  'glide-g',
  'shoelace',
  'facebook-f',
  'odysee',
  'replyd',
  'uniregistry',
  'square-js',
  'firefox-browser',
  'hornbill',
  'sass',
  'cloudflare',
  'btc',
  'wodu',
  'steam-symbol',
  'rockrms',
  'goodreads-g',
  'vaadin',
  'nimblr',
  'speaker-deck',
  'cc-amex',
  'cotton-bureau',
  'bandcamp',
  'mix',
  'blogger-b',
  'cloudscale',
  'draft2digital',
  'superpowers',
  'markdown',
  'uikit',
  'sistrix',
  'galactic-republic',
  'square-pinterest',
  'square-reddit',
  'css3-alt',
  'uncharted',
  'pied-piper-hat',
  'creative-commons-sampling',
  'creative-commons-pd',
  'empire',
  'keycdn',
  'node-js',
  'creative-commons',
  'guilded',
  'creative-commons-share',
  'google-play',
  'fort-awesome',
  'strava',
  'linode',
  'chromecast',
  'adversal',
  'facebook-messenger',
  'bilibili',
  'palfed',
  'xbox',
  'foursquare',
  'hackerrank',
  'react',
  'square-xing',
  'cc-visa',
  'rocketchat',
  'microsoft',
  'drupal',
  'sellcast',
  'vimeo',
  'vnv',
  'angellist',
  'vine',
  'asymmetrik',
  'reddit-alien',
  'teamspeak',
  'square-bluesky',
  'square-odnoklassniki',
  'internet-explorer',
  'suse',
  'symfony',
  'square-gitlab',
  'vk',
  'get-pocket',
  'square-behance',
  'neos',
  'ravelry',
  'buromobelexperte',
  'html5',
  'uber',
  'goodreads',
  'ello',
  'd-and-d-beyond',
  'typo3',
  'yoast',
  'megaport',
];

export const fontAwesomeV6BrandIconsMap = new Map(
  fontAwesomeV6BrandsIconsList.map(icon => [icon, icon]),
);
